'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollchor = function (_React$Component) {
  _inherits(Scrollchor, _React$Component);

  function Scrollchor(props) {
    _classCallCheck(this, Scrollchor);

    var _this = _possibleConstructorReturn(this, (Scrollchor.__proto__ || Object.getPrototypeOf(Scrollchor)).call(this, props));

    _this._handleClick = function (event) {
      _this.state.beforeAnimate(event);
      event && event.preventDefault();
      (0, _helpers.animateScroll)(_this.state.to, _this.state.animate).then(function (id) {
        if (id) {
          _this.state.disableHistory || (0, _helpers.updateHistory)(id);
          _this.state.afterAnimate(event);
        }
      });
    };

    _this.state = Scrollchor._stateHelper(props);
    _this.simulateClick = _this._handleClick;
    return _this;
  }

  _createClass(Scrollchor, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(Scrollchor._stateHelper(props));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          animate = _props.animate,
          beforeAnimate = _props.beforeAnimate,
          afterAnimate = _props.afterAnimate,
          disableHistory = _props.disableHistory,
          props = _objectWithoutProperties(_props, ['to', 'animate', 'beforeAnimate', 'afterAnimate', 'disableHistory']); // eslint-disable-line no-unused-vars

      return !this.props.children ? null : _react2.default.createElement('a', _extends({}, props, { href: '#' + this.state.to, onClick: this._handleClick }));
    }
  }], [{
    key: '_stateHelper',
    value: function _stateHelper(props) {
      var _ref = props.animate || {},
          _ref$offset = _ref.offset,
          offset = _ref$offset === undefined ? 0 : _ref$offset,
          _ref$duration = _ref.duration,
          duration = _ref$duration === undefined ? 400 : _ref$duration,
          _ref$easing = _ref.easing,
          easing = _ref$easing === undefined ? easeOutQuad : _ref$easing;

      return {
        to: props.to && props.to.replace(/^#/, '') || '',
        animate: { offset: offset, duration: duration, easing: easing },
        beforeAnimate: props.beforeAnimate || function () {},
        afterAnimate: props.afterAnimate || function () {},
        disableHistory: props.disableHistory
      };
    }
  }, {
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      return Scrollchor._stateHelper(props);
    }
  }]);

  return Scrollchor;
}(_react2.default.Component);

// Default easing function
// jQuery easing 'swing'


Scrollchor.propTypes = {
  to: _propTypes2.default.string.isRequired,
  animate: _propTypes2.default.shape({
    offset: _propTypes2.default.number,
    duration: _propTypes2.default.number,
    easing: _propTypes2.default.func
  }),
  beforeAnimate: _propTypes2.default.func,
  afterAnimate: _propTypes2.default.func,
  disableHistory: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
exports.default = Scrollchor;
function easeOutQuad(x, t, b, c, d) {
  return -c * (t /= d) * (t - 2) + b;
}

// Setup for React version 16.3.x and beyond
var reSemver = /^v?((\d+)\.(\d+)\.(\d+))(?:-([\dA-Za-z\-]+(?:\.[\dA-Za-z\-]+)*))?(?:\+([\dA-Za-z\-]+(?:\.[\dA-Za-z\-]+)*))?$/; // eslint-disable-line no-useless-escape

var _reSemver$exec = reSemver.exec(_react2.default.version),
    _reSemver$exec2 = _slicedToArray(_reSemver$exec, 4),
    major = _reSemver$exec2[2],
    minor = _reSemver$exec2[3];

major >= 16 && minor >= 3 && delete Scrollchor.prototype.componentWillReceiveProps;


//////////////////
// WEBPACK FOOTER
// ./~/react-scrollchor/lib/scrollchor.js
// module id = 137
// module chunks = 35783957827783